import {MyCheckboxStyles} from "./MyCheckbox.styles";
import {MyCheckboxProps} from "./MyCheckbox.props";
import cl from 'classnames'
import React from "react";

export const MyCheckbox = (props:MyCheckboxProps): React.ReactElement => {
  const {size} = props
  return (
    <MyCheckboxStyles {...props} className={cl({
      [`size-${size}`]: size,
    })}/>
  )
}